import api from "../index";

export const GetTransactionsApi = (userId, params) => api.get(`UserMaster/GetTransaction-ByUserId?${params}`);

export const GetUserScalpingDealsExcelApi = (transactionId) =>
    api.get(`Admin/get-user-scalping-deals-excel/${transactionId}`, { responseType: 'blob' });
